import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { EnvironmentThemeProvider } from '@codex/themes';

import Select from './Select';


const SortByWrappper = styled.div`
  display: flex; 
  width: 100%;
  
  & input {
    cursor: pointer;
  }
  
  ${({ theme }) => css`
    @media ${theme.breakpoints.mobile} {
      div:nth-child(2) {
        width: 100%;
      }
    }
  `};
`;

const SortByLabel = styled.div`
  margin-right: 10px;
  padding-top: 13px;
  padding-bottom: 13px;
  font-size: 13px;
  transform: none;
  white-space: nowrap;
  
  ${({ theme }) => css`
    color: ${theme.colors.shades[2]};
    
    @media ${theme.breakpoints.mobile} {
      display: none;
    }
  `};
`;

const StyledSelect = styled(Select)`
  width: 190px;
`;

const SortBy = ({
  title, options, defaultOptionIndex, onSelectedItemChange
}) => (
  <EnvironmentThemeProvider>
    <SortByWrappper>
      <SortByLabel>{title}</SortByLabel>
      <StyledSelect
        options={options}
        defaultOptionIndex={defaultOptionIndex}
        onSelectedItemChange={onSelectedItemChange}
      />
    </SortByWrappper>
  </EnvironmentThemeProvider>
);

SortBy.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  }).isRequired).isRequired,
  defaultOptionIndex: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  onSelectedItemChange: PropTypes.func
};

SortBy.defaultProps = {
  onSelectedItemChange: () => {}
};
export default SortBy;
